import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep, set } from "lodash";
import { updateDashboardByName } from "../../../../Utils/Sockets";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { projectReducer } = store.getState();
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    uuid,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  if (values?.projectPriority?.value)
    set(data, "projectPriority", values?.projectPriority?.value);

  if (values?.projectType?.value)
    set(data, "projectType.uuid", values?.projectType?.value);

  if (values?.projectClient?.value)
    set(data, "projectClient.uuid", values?.projectClient?.value);

  if (values?.projectManager?.value)
    set(data, "projectManager.uuid", values?.projectManager?.value);

  let payload;

  if (!update) {
    data.status = projectReducer?.availableStatuses?.find(
      (el) => !!el.isSelected
    );

    const res = await GlobalAuthFetch({
      path: `/project`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/project/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();

  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};
  const errorsStep1 = {};

  if (!values.projectName) {
    errorsStep0.projectName = t("global:project.errors.projectName");
  }

  if (values.projectName && values.projectName.length > 50) {
    errorsStep0.projectName = `${t(
      "global:project.errors.projectNameLength"
    )} (aktualna ilość znaków ${values.projectName.length}) max. ${50}`;
  }

  if (!values.projectDescription) {
    errorsStep0.projectDescription = t(
      "global:project.errors.projectDescription"
    );
  }
  if (values.projectDescription && values.projectDescription.length > 255) {
    errorsStep0.projectDescription = `${t(
      "global:project.errors.projectDescriptionLength"
    )} (aktualna ilość znaków ${values.projectDescription.length}) max. ${255}`;
  }
  if (!values.projectClient) {
    errorsStep0.projectClient = t("global:project.errors.projectClient");
  }
  if (!values.projectManager) {
    errorsStep0.projectManager = t("global:project.errors.projectManager");
  }

  if (!values.projectDeadline) {
    errorsStep0.projectDeadline = t("global:project.errors.projectDeadline");
  }

  if (
    (!values.projectParticipants || values.projectParticipants.length === 0) &&
    (!values.participatingUnits || values.participatingUnits.length === 0)
  ) {
    errorsStep1.projectParticipants = t(
      "global:project.errors.projectParticipantsOrUnits"
    );
    errorsStep1.participatingUnits = t(
      "global:project.errors.projectParticipantsOrUnits"
    );
  }

  const hasErrorsStep0 = Object.keys(errorsStep0).length > 0;
  const hasErrorsStep1 = Object.keys(errorsStep1).length > 0;

  if (props.isSubmit && props.steps[0]?.error !== hasErrorsStep0) {
    props.setErrorHeader(0, hasErrorsStep0);
  }

  if (props.isSubmit && props.steps[1]?.error !== hasErrorsStep1) {
    props.setErrorHeader(1, hasErrorsStep1);
  }

  return { ...errorsStep0, ...errorsStep1 };
};
